<template>
  <div class="title">
    <h1>{{title}}</h1>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Info',
  props: {
    title: String,
    description: String
  }
}
</script>

<style scoped lang="scss">
  .title {
    margin-bottom: 20px;
    text-align: center;
  }
</style>
